import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import { fetchPreSaleGymLeadsData } from "../../../redux/prospect-reducers/prospectSlice";
import PreSaleGymLeadsListings from "./PreSaleGymLeadsListings";
import CmnFilters from "../common/CmnFilters";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";
import ModalCloseStart from "../../payouts-wtf/common/ModalCloseStart";
import AddLeadForm from "../AddLeadForm";
import LeadJourney from "../lms-v2/lead-journey/LeadJourney";

const PreSaleGymLeadsStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { preSaleGymLeadsLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selCity: "",
    selLeadStatus: "",
    selAddNotAddToLead: "",
    searchString: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    preferred_location: allFilters.selCity?.value || "",
    lead_status: allFilters.selLeadStatus?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: null,
    selectedRows: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
    setSearchFilterApplied(false);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllLeads(filters) {
    dispatch(
      fetchPreSaleGymLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllLeads(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      preferred_location: allFilters.selCity?.value || "",
      lead_status: allFilters.selLeadStatus?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selCity,
    allFilters.selLeadStatus,
    allFilters.selAddNotAddToLead,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : ""
          }`}
        >
          {modValues.modName === "add-to-lead" ? null : modValues.modName ===
            "view-lead-journey" ? (
            <ModalCloseStart
              title={`Lead Details - ${
                modValues.rowData?.name || modValues.rowData?.full_name || ""
              }`}
              onClose={onCloseModal}
            />
          ) : null}

          {modValues.modName === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={onCloseModal}
              callFunction={() => getAllLeads(filters)}
              rowData={modValues.rowData}
              isPreSaleLead={true}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Pre Sale Gym Leads"
            subheading="Manage pre-sale gym leads"
            onReload={() => getAllLeads(filters)}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="pre-sale-gym-leads"
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isLoading={preSaleGymLeadsLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <PreSaleGymLeadsListings
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            callFunction={() => getAllLeads(filters)}
          />
        </Col>
      </Row>
    </>
  );
};

export default PreSaleGymLeadsStructure;
